
import React from 'react'
import { Route, Redirect } from 'react-router-dom'
import { getServiceToken, getBSRSToken } from './'

const Auth = {
	isAuthenticated: () => {
		const bsrsToken = getBSRSToken()
		// const serviceToken = getServiceToken()
		
		return !!bsrsToken /*&& !!serviceToken.service_token*/
	},
	isIntegration: () => {
		return true
	}
}

const PrivateRoute = ({ component: Component, ...rest }) => {
	return <Route {...rest} render={(props) => {

		if (Auth.isAuthenticated() == false && props.match.url != "/login") {
			return <Redirect to='/login' />
		}

		if (Auth.isIntegration() == false && props.match.url != "/integration") {
			return <Redirect to='/integration' />
		}

		if (Component != undefined) {
			return <Component {...props} />
		} else {
			return <Redirect to='/' />
		}
	}} />
}

const PublicRoute = ({ component: Component, ...rest }) => {
	return <Route {...rest} render={(props) => {

		if (Auth.isAuthenticated() == true && props.match.url == "/login") {
			return <Redirect to='/' />
		}

		if (Component != undefined) {
			return <Component {...props} />
		} else {
			return ""
		}
	}} />
}

export default {
	PrivateRoute,
	PublicRoute,
}


// WEBPACK FOOTER //
// ./src/lib/routePermission.js